import { createFileRoute } from "@tanstack/react-router";
import LoadingPage from "lib/components/layout/LoadingPage";
import withAuthentication from "../../../../components/withAuthentication";

/**
 * Operations mode for a saved `HomePlan`. Exposes `OPERATIONS`-category
 * options and renders a flat grouped list instead of the wizard — ops users
 * want Ctrl+F over a guided flow. Gated on `showroomUnification`.
 */
function ShowroomPlanOps() {
  return <LoadingPage pageTitle="Showroom" />;
}

export const Route = createFileRoute("/showroom/plan/$home_plan_id/ops")({
  component: withAuthentication(ShowroomPlanOps, {
    features: ["showroomUnification"],
    permissions: ["VIEW_OPERATIONS_MODE", "VIEW_HOME_PLANS"],
    products: ["showroom"],
  }),
});
